// Read-only safety flag. Activate with `?readonly=1` on localhost (dev only).
// When active, all mutation call sites must short-circuit so automated UX
// testers can click through the UI without touching the live tb_tasks rows.
//
// Usage at a mutation call site:
//   if (READONLY) return;
//   await supabase.from('tb_tasks').update(...).eq(...);
//
// Purely a dev-time tool. In production builds (`import.meta.env.DEV === false`)
// READONLY is always false and the branch is dead code.

export const READONLY =
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('readonly') === '1';

export function guardMutation<T>(
  action: () => Promise<T>,
  label = 'mutation',
): Promise<T | undefined> {
  if (READONLY) {
    // eslint-disable-next-line no-console
    console.info(`[readonly] blocked ${label}`);
    return Promise.resolve(undefined);
  }
  return action();
}
